const blog = {
  content: {
    title: 'Blog Creditas',
  },
};
export { blog };
